<template>
  <CustomMarker
    :class="`custom-marker ${isSelectedOrHighlighted ? 'highlighted' : ''} ${listing.latlng ? '' : 'd-none'}`"
    :options="options"
    :style="`opacity:1;z-index:99;`"
    @click.stop="click"
    @mouseover.stop="highlight"
    @mouseout.stop="unhighlight"
  >
    <CustomMarkerIcon
      :icon="listing.listingSource?.iconUrl"
      color="4171d9"
    />
  </CustomMarker>
</template>

<script>
import {CustomMarker} from "vue3-google-map";
import CustomMarkerIcon from "@/components/common/CustomMarkerIcon.vue";
import {Listing} from "@/models/Listing";
export default {
  components: {
    CustomMarker,
    CustomMarkerIcon
  },
  props: {
    listing: Listing,
    selectedId: String
  },
  computed: {
    options() {
      return {
        title: this.listing.addressFormatted,
        position: this.listing.latlng,
        optimized: true
      };
    },
    isSelectedOrHighlighted() {
      return this.selected || this.$ui.isHighlighted(this.listing.id);
    },
    selected() {
      return this.selectedId === this.listing.id;
    },
  },
  methods: {
    click() {
      this.$router.push({
        name: 'listing-detail',
        params: {selectedListingId: this.listing.id}
      });
    },
    highlight() {
      this.$ui.setHighlighted(this.listing.id, 'map');
    },
    unhighlight() {
      this.$ui.clearHighlighted('map');
    }
  }
}
</script>

<style>
.custom-marker {
  z-index: 1;
  transition: scale 250ms, z-index 0ms linear 250ms;
}
.custom-marker.highlighted {
  z-index: 100!important;
  transition: z-index 0ms linear 0ms;
}
.custom-marker.highlighted>.custom-marker-icon {
  scale: 2;
  transition: scale 250ms;
}
</style>
